import en from './en.json';
import id from './id.json';

import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({
	en,
	id,
});